angular.module('picmonicng').directive('ensureUnique', [
  '$http',
  '$q',
  function ($http, $q) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModelController) {
        ngModelController.$asyncValidators.unique = function (modelValue, viewValue) {
          return $http
            .post('api/v2/checkuniqueness/' + attrs.ensureUnique, {
              fieldValue: viewValue,
            })
            .then(function (results) {
              if (!results.data.isUnique) {
                return $q.reject(results.data.message);
              }
              return true;
            });
        };
      },
    };
  },
]);
